module.exports = __webpack_public_path__ + "src/downloads/resume_mark_condello.a77dddb5.pdf";